import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function View({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-0.5 -6.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path d="M19.432 20.982c-4.091 0-7.41-3.335-7.41-7.442 0-4.108 3.319-7.442 7.41-7.442 4.09 0 7.409 3.334 7.409 7.442 0 4.107-3.319 7.442-7.409 7.442zm0-19.881c-8.256 0-15.307 5.158-18.164 12.439 2.857 7.281 9.908 12.439 18.164 12.439 8.256 0 15.307-5.158 18.163-12.439-2.856-7.281-9.907-12.439-18.163-12.439z" />
      </g>
    </svg>
  )
}

View.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
